import { Text, type TextLevel, type TitleNode } from '@commons/components/Text';
import type { DrupalBlock } from '@commons/types/drupal';
import type { Color, FontWeight } from '@commons/types/styles';

// Type definition for the TitleBlock component properties.

type Props = DrupalBlock<{
  as: TitleNode;
  title: string;
  level?: TextLevel;
  color?: Color;
  weight?: FontWeight;
}>;

/**
 * Title block component.
 */

const TitleBlock = ({ content }: Props) => {
  const { title, ...props } = content;

  return (
    <Text {...props} marginBottom="none">
      {title}
    </Text>
  );
};

export default TitleBlock;
